export function initDetail() {
    console.log('Detail initialized!')
    collapsibleDescriptionSections()
    $('.p-image').addClass('ready')
}

function collapsibleDescriptionSections() {
    const basicDescription = document.querySelector('.basic-description')
    const target = document.querySelector('#product-detail-form')
    const wrapper = document.createElement('div')
    wrapper.className = 'detail-parameters-wrapper'

    // Helper function to extract sections
    function extractSections() {
        const sections = []
        let currentSection = null
        const elements = Array.from(basicDescription.children)

        elements.forEach((element) => {
            const text = element.textContent.trim()

            if (text.startsWith('#tab-')) {
                if (currentSection) {
                    sections.push(currentSection)
                }
                currentSection = {
                    title: text.replace('#tab-', ''),
                    content: [],
                }
            } else if (currentSection && text.length > 0) {
                currentSection.content.push(element.cloneNode(true))
            }
        })

        if (currentSection) {
            sections.push(currentSection)
        }

        return sections
    }

    // Create collapsible sections
    extractSections().forEach((section) => {
        const sectionElement = document.createElement('div')
        sectionElement.className = 'custom-detail-parameter'

        const contentWrapper = document.createElement('div')
        section.content.forEach((element) => contentWrapper.appendChild(element))

        sectionElement.innerHTML = `
        <div class="detail-parameter-header">
          <h4 class="detail-parameter-trigger">
            ${section.title}
            <span class="detail-parameter-icon plusminus"></span>
          </h4>
        </div>
        <div class="detail-parameter-content">
          ${contentWrapper.innerHTML}
        </div>
      `

        const trigger = sectionElement.querySelector('.detail-parameter-trigger')
        const contentDiv = sectionElement.querySelector('.detail-parameter-content')
        const icon = sectionElement.querySelector('.plusminus')

        trigger.addEventListener('click', () => {
            icon.classList.toggle('active')

            if (contentDiv.style.maxHeight) {
                contentDiv.style.maxHeight = null
                contentDiv.style.opacity = 0
            } else {
                contentDiv.style.maxHeight = contentDiv.scrollHeight + 'px'
                setTimeout(() => {
                    contentDiv.style.opacity = 1
                }, 200)
            }
        })

        wrapper.appendChild(sectionElement)
    })

    target.insertAdjacentElement('afterend', wrapper)
}
